import { combineReducers } from 'redux';
import {
  FETCH_ALGOS_LIVE_REQUEST,
  FETCH_ALGOS_LIVE_SUCCESS,
  FETCH_ALGOS_LIVE_FAILURE,
  FETCH_ALGO_LIVE_BY_ID_REQUEST,
  FETCH_ALGO_LIVE_BY_ID_SUCCESS,
  FETCH_ALGO_LIVE_BY_ID_FAILURE,
} from '../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGOS_LIVE_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGOS_LIVE_SUCCESS:
      console.log(action.data.data);

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGOS_LIVE_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGO_LIVE_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGO_LIVE_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data,
      };
    case FETCH_ALGO_LIVE_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const algosLive = combineReducers({
  list,
  selected,
});

export default algosLive;
